import { render } from "./App.vue?vue&type=template&id=34accb2d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=34accb2d&lang=css"

import exportComponent from "/home/jay/Code/dm-sokoban-leveleditor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__